interface Player {
    getSupportedDRM(): Promise<string[]>;
}

export async function isDRMSupported(player: Player): Promise<boolean> {
    const keySystems: { [key: string]: string[] } = {
        widevine: ['com.widevine.alpha'],
        playready: ['com.microsoft.playready', 'com.youtube.playready'],
        primetime: ['com.adobe.primetime', 'com.adobe.access'],
        fairplay: ['com.apple.fps.1_0', 'com.apple.fps.2_0'],
    };

    let supported = false;
    const drmSystems = await player?.getSupportedDRM();

    drmSystems?.forEach((drm) => {
        Object.keys(keySystems).forEach((key) => {
            if (keySystems[key].indexOf(drm) !== -1) {
                supported = true;
            }
        });
    });

    return supported;
}
